import React, { useEffect, useState } from 'react';
import '../styles/GeneralDonate.css';
import environment from '../config/environment';

const SALESFORCE_DONATION_BASE =
  'https://npoproto--mvp.sandbox.my.site.com/donate/s/donate?slug=';

const GeneralDonate = () => {
  const { apiUrl } = environment();
  const [causesData, setCauses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCauses = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(`${apiUrl}/api/salesforce-public-causes`, {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Failed to load causes (${response.status})`);
        }

        const data = await response.json();
        const causes = data?.data?.causes || [];
        setCauses(causes);
      } catch (err) {
        console.error('Failed to fetch Salesforce public causes:', err);
        setError('Unable to load causes right now.');
      } finally {
        setLoading(false);
      }
    };

    fetchCauses();
  }, [apiUrl]);

  const handleCauseSelect = (slug) => {
    if (!slug) return;

    const targetUrl = `${SALESFORCE_DONATION_BASE}${encodeURIComponent(slug)}`;
    window.location.href = targetUrl;
  };

  if (loading) {
    return (
      <div className="donate-wrapper">
        <div className="donate-container">
          <div className="loading-state">Loading causes...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="donate-wrapper">
        <div className="donate-container">
          <div className="error-state">
            {error}
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="donate-wrapper">
      <div className="donate-container">
        <div className="donate-header">
          <h1>Support Our Causes</h1>
          <p>Choose where to direct your support</p>
        </div>

        <div className="cause-selector-section">
          <div className="cause-selector-wrapper">
            <select
              className="cause-selector"
              onChange={(e) => handleCauseSelect(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>Select a cause to support</option>
              {causesData.map((cause) => (
                <option key={cause.slug || cause.widgetId} value={cause.slug}>
                  {cause.projectName || cause.widgetName}
                </option>
              ))}
            </select>
          </div>

          <div className="cause-description">
            <p>
              Select a specific cause to support and you’ll be taken to that cause’s
              secure donation page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralDonate;